export const getICSData = (
  title: string,
  desc: string,
  loc: string,
  startDateTime: string,
  endDateTime: string,
) => {
  return `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
CLASS:PUBLIC
DESCRIPTION:${desc}
DTSTART:${startDateTime}
DTEND:${endDateTime}
LOCATION:${loc}
SUMMARY;LANGUAGE=en-us:${title}
END:VEVENT
END:VCALENDAR`;
};
